module.exports = __webpack_public_path__ + "img/014.84db4694.png";